import { callApi, callApiWithData } from './call-api';
import { Ingredient } from '../models/ingredient';

export const getIngredients = async (): Promise<Ingredient[]> => {
  const response = await callApi('/ingredients');
  return response.ingredients;
};

export const createIngredient = async (name: string): Promise<Ingredient> => {
  const response = await callApiWithData('/ingredient', { name }, 'POST');
  return response.ingredient;
};

export const resolveIngredientIds = async (
  ingredients: { ingredientId: string; name: string; quantity: string }[]
): Promise<{ ingredientId: string; quantity: string }[]> => {
  const withId = ingredients.filter((i) => i.ingredientId !== '');
  const withoutId = ingredients.filter((i) => i.ingredientId === '' && i.name.trim() !== '');

  if (withoutId.length === 0) {
    return withId.map((i) => ({ ingredientId: i.ingredientId, quantity: i.quantity }));
  }

  const available = await getIngredients();
  const resolved = withId.map((i) => ({ ingredientId: i.ingredientId, quantity: i.quantity }));

  for (const item of withoutId) {
    const match = available.find((a) => a.name.toLowerCase() === item.name.trim().toLowerCase());
    if (match) {
      resolved.push({ ingredientId: match.id, quantity: item.quantity });
    } else {
      const created = await createIngredient(item.name.trim());
      resolved.push({ ingredientId: created.id, quantity: item.quantity });
    }
  }

  return resolved;
};
